import { axios } from "../config";

function createEvent(data) {
  return axios.post(`/api/v1/event/create-event`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function updateEvent(data, id) {
  return axios.put(`/api/v1/event/update-event/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function getEvent(month, year) {
  return axios.get(`/api/v1/event/fetch-events?month=${month}&year=${year}`);
}

function deleteEvent(id) {
  return axios.delete(`/api/v1/event/delete-event/${id}`);
}

export { createEvent, updateEvent, getEvent, deleteEvent };
